import { requestV1 } from './base'
import { Doors, Keyword } from './response_types'

export const getKeywordDoors = async (
  page: number = 1,
  keyword?: string,
  per?: number
) => {
  return await requestV1<Doors>(
    'get',
    `/doors?page=${page}&keyword=${keyword}&per=${per}`
  )
}

export const listKeyword = async () => {
  return await requestV1<Array<Keyword>>('get', `/keywords`)
}

export const getKeyword = async (word_en: string) => {
  return await requestV1<Keyword>('get', `/keywords/${word_en}`)
}
